import { useState } from "react";
import ActionModal from "./ActionModal";
import type { AcceptButtonDetails } from "./types";
import { TextAreaField } from "@/components/common/text-field";

interface Props {
  isLoading?: boolean;
  isExtension?: boolean;
  isOpen: boolean;
  onClose: () => void;
  acceptButtonDetails: AcceptButtonDetails;
  onDeny: (reason: string) => void;
}

/**
 * Modal to deny a suspension request with a reason.
 * used in the ExtensionMainModal component.
 * used in the ApproveSuspensionInfo component.
 * @param param0
 * @returns
 */
const DenyModal = ({
  isLoading,
  isOpen,
  onClose,
  acceptButtonDetails,
  onDeny,
  isExtension = true,
}: Props) => {
  const [reason, setReason] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    setReason(value);
  };

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleAccept = async () => {
    onDeny(reason);
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleClose}
      onAccpet={handleAccept}
      title={isExtension ? "Denegar prórroga" : "Denegar plazo"}
      description="¿Estás seguro de que deseas denegar la solicitud?"
      acceptButtonDetails={{
        ...acceptButtonDetails,
        disabled: reason.trim().length <= 0 || reason.trim().length > 120,
        isLoading,
      }}
    >
      <div>
        <TextAreaField
          required
          id="deny-reason"
          label={
            isExtension
              ? "¿Por qué rechazas esta solicitud de prórroga?"
              : "¿Por qué rechazas esta solicitud de suspensión de plazo?"
          }
          value={reason}
          onChange={handleChange}
          placeholder="Escribe tu comentario..."
          limit={120}
          countAlign="right"
          count={reason.length}
        />
      </div>
    </ActionModal>
  );
};

export default DenyModal;
